"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetDownloadIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.NetDownloadIcon16Light = forwardRef_1.forwardRef('NetDownloadIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.5 1a.5.5 0 0 1 .5.5v8.373c.056-.032.109-.07.159-.114l3.012-2.635a.5.5 0 1 1 .658.752l-3.012 2.636a2 2 0 0 1-2.634 0L3.171 7.876a.5.5 0 1 1 .658-.752l3.013 2.635c.05.044.102.082.158.114V1.5a.5.5 0 0 1 .5-.5Z" }),
        react_1.default.createElement("path", { d: "M1 13.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5Z" })));
});
